export class BookingChange {
  constructor() {
    this.userId = undefined;
    this.user = undefined;
    this.created = undefined;
    this.changeFlags = 0;
    this.changes = [];
    this.message = undefined;
  }

  static fromJSON(json) {
    if(!json) return undefined;

    let entry = Object.assign(new BookingChange(), json);
    if(entry.changes) {
      entry.changes = entry.changes.map(e => {
        return ChangeEntry.fromJSON(e);
      })
    }
    return entry;
  }
}

export class ChangeEntry {
  constructor() {
    this.changeType = 0;
    this.oldValue = undefined;
    this.newValue = undefined;
  }

  static fromJSON(json) {
    if(!json) return undefined;

    return Object.assign(new ChangeEntry(), json);
  }
}

export class BOOKING_CHANGE_TYPE {
  static NoChange = 0;
  static BookingState = 1;
  static ArrivalState = 2;
  static Tags = 4;
  static Table = 8;
  static GuestCount = 16;
  static Arrival = 32;
  static Departure = 64;
  static Budget = 128;
  static Caseworker = 256;
  static OrderLines = 512;
  static Section = 1024;
  static Created = 2048;
  static Deleted = 4096;

  static nameof(changeType) {
    switch (changeType) {
      case BOOKING_CHANGE_TYPE.NoChange: {
        return 'No change';
      }
      case BOOKING_CHANGE_TYPE.BookingState: {
        return 'Booking state';
      }
      case BOOKING_CHANGE_TYPE.ArrivalState: {
        return 'Arrival state';
      }
      case BOOKING_CHANGE_TYPE.Tags: {
        return 'Tags';
      }
      case BOOKING_CHANGE_TYPE.Table: {
        return 'Table';
      }
      case BOOKING_CHANGE_TYPE.GuestCount: {
        return 'Guest count';
      }
      case BOOKING_CHANGE_TYPE.Arrival: {
        return 'Arrival';
      }
      case BOOKING_CHANGE_TYPE.Departure: {
        return 'Departure';
      }
      case BOOKING_CHANGE_TYPE.Budget: {
        return 'Budget';
      }
      case BOOKING_CHANGE_TYPE.Caseworker: {
        return 'Requested rejected';
      }
      case BOOKING_CHANGE_TYPE.OrderLines: {
        return 'Order lines';
      }
      case BOOKING_CHANGE_TYPE.Section: {
        return 'Section';
      }
      case BOOKING_CHANGE_TYPE.Created: {
        return 'Created';
      }
      case BOOKING_CHANGE_TYPE.Deleted: {
        return 'Deleted';
      }
    }
  }
}
